export const getters = {
  GET_MBO_CURR_INFO: "GET_MBO_CURR_INFO", //* MBO 현황 정보가져오기
  GET_MBO_LIST: "GET_MBO_LIST", //* MBO 목록 리스트 가져오기
  GET_MBO_NAME_LIST: "GET_MBO_NAME_LIST", //* MBO명 DROPDOWN 리스트 가져오기
  GET_MBO_MODIFY_TARGET_INFO: "GET_MBO_MODIFY_TARGET_INFO", //* MBO 수정목표 DATA
  GET_VIEWS_MBO_MODIFY_TARGET_POP: "GET_VIEWS_MBO_MODIFY_TARGET_POP", //* MBO 수정목표 팝업 ON/OFF
  GET_VIEWS_MBO_KPI_POPUP: "GET_VIEWS_MBO_KPI_POPUP", //* MBO 항목(KPI) 팝업 ON/OFF 가져오기
  GET_MBO_KPI_POOL_LIST: "GET_MBO_KPI_POOL_LIST", //* MBO 항목(KPI) 가져오기
  //GET_IS_SELECTED_NEW_KPI: 'GET_IS_SELECTED_NEW_KPI', //* 선택한 MBO 항목(KPI) 가져오기
  GET_MBO_BOARD_TAB: "GET_MBO_BOARD_TAB", //* MBO 현황탭 ON/OFF
  GET_MBO_LIST_TAB: "GET_MBO_LIST_TAB", //* MBO 목록탭 ON/OFF
  GET_SELECTED_TARGET_MBO_KPI: "GET_SELECTED_TARGET_MBO_KPI", //* 선택한 수정목표 MBO 항목 가져오기
  GET_CHANGED_TARGET_MBO_KPI: "GET_CHANGED_TARGET_MBO_KPI", //* 목표를 수정한 MBO KPI 가져오기
  GET_SELECTED_MBO_INFO: "GET_SELECTED_MBO_INFO", //* MBO목록에서 선택한 MBO 정보 가져오기
  GET_MBO_HISTORY_LIST: "GET_MBO_HISTORY_LIST", //* MBO 변경이력
  GET_MBO_HISTORY_CODE: "GET_MBO_HISTORY_CODE", //* MBO 변경이력 코드
  GET_VIEWS_MBO_HISTORY_POPUP: "GET_VIEWS_MBO_HISTORY_POPUP" //* MBO 변경이력 팝업 ON/OFF 가져오기
};

export const actions = {
  // TODO FETCH
  FETCH_MBO_CURR_INFO: "FETCH_MBO_CURR_INFO", //* MBO 현황 정보가져오기
  FETCH_MBO_LIST: "FETCH_MBO_LIST", //* MBO 목록 리스트 가져오기
  FETCH_MBO_NAME_LIST: "FETCH_MBO_NAME_LIST", //* MBO명 DROPDOWN 리스트 가져오기
  FETCH_MBO_MODIFY_TARGET_INFO: "FETCH_MBO_MODIFY_TARGET_INFO", //* MBO 수정목표 DATA
  FETCH_MBO_KPI_POOL_LIST: "FETCH_MBO_KPI_POOL_LIST", //* MBO 항목(KPI) 가져오기
  FETCH_MBO_HISTORY_LIST: "FETCH_MBO_HISTORY_LIST", //* MBO 이력 가져오기

  // TODO INIT
  INIT_VIEWS_MBO_MODIFY_TARGET_POP: "INIT_VIEWS_MBO_MODIFY_TARGET_POP", //* MBO 수정목표 팝업 ON/OFF
  INIT_VIEWS_MBO_KPI_POPUP: "INIT_VIEWS_MBO_KPI_POPUP", //* MBO 항목(KPI) 팝업 ON/OFF 초기화
  INIT_VIEWS_MBO_HISTORY_POPUP: "INIT_VIEWS_MBO_HISTORY_POPUP", //* MBO 변경 이력 팝업 ON/OFF 초기화
  INIT_MBO_KPI_POOL_LIST: "INIT_MBO_KPI_POOL_LIST", //* MBO 항목(KPI) 초기화
  //INIT_IS_SELECTED_NEW_KPI: 'INIT_IS_SELECTED_NEW_KPI', //* 선택한 MBO 항목(KPI) 초기화
  INIT_MBO_BOARD_TAB: "INIT_MBO_BOARD_TAB", //* MBO 현황탭 ON/OFF 초기화
  INIT_MBO_LIST_TAB: "INIT_MBO_LIST_TAB", //* MBO 현황탭 ON/OFF 초기화
  INIT_SELECTED_TARGET_MBO_KPI: "INIT_SELECTED_TARGET_MBO_KPI", ///* 선택한 수정목표 MBO 항목 초기화
  INIT_CHANGED_TARGET_MBO_KPI: "INIT_CHANGED_TARGET_MBO_KPI", //* 목표를 수정한 MBO KPI 초기화
  INIT_SELECTED_MBO_INFO: "INIT_SELECTED_MBO_INFO", //* MBO목록에서 선택한 MBO 정보

  // TODO INSERT
  INSERT_MBO_KPI_LIST: "INSERT_MBO_KPI_LIST", //* MBO 항목 > KPI 추가
  INSERT_MBO_KPI_LIST1: "INSERT_MBO_KPI_LIST", //* MBO 항목 > KPI 추가

  // TODO SAVE
  SAVE_MBO_OPER_LIST: "SAVE_MBO_OPER_LIST", //* MBO 현황 저장(임시저장, 결재관련)
  SAVE_MBO: "SAVE_MBO", //* MBO 현황 저장(임시저장, 결재관련)

  // TODO UPDATE
  UPDATE_MBO_APV_STATUS: "UPDATE_MBO_APV_STATUS", //* MBO 승인상태 변경
  UPDATE_MBO_TARGET_STATUS: "UPDATE_MBO_TARGET_STATUS", //* MBO 목표 수정 상태 변겨

  UPDATE_INIT_MBO_APV_STATUS: "UPDATE_INIT_MBO_APV_STATUS", //* MBO 승인상태 초기화 (관리자 기능);
  UPDATE_MBO_KPI_TARGET_MONTH_DATA: "UPDATE_MBO_KPI_TARGET_MONTH_DATA", //*KPI 월 수정목표 저장
  UPDATE_MBO_KPI_TARGET_WEEK_DATA: "UPDATE_MBO_KPI_TARGET_WEEK_DATA", //*KPI 주 수정목표 저장

  // TODO DELETE
  DELETE_MBO_KPI: "DELETE_MBO_KPI", //* MBO KPI 삭제

  SAVE_USER_HISTORY: "SAVE_USER_HISTORY" //* MBO USER HISTORY - 직급
};

export const mutations = {
  SET_MBO_CURR_INFO: "SET_MBO_CURR_INFO", //* MBO 현황 정보 데이터 세팅
  SET_MBO_LIST: "SET_MBO_LIST", //* MBO 목록 리스트 데이터 세팅
  SET_MBO_NAME_LIST: "SET_MBO_NAME_LIST", //* MBO명 DROPDOWN 데이터 세팅
  SET_MBO_MODIFY_TARGET_INFO: "SET_MBO_MODIFY_TARGET_INFO", //* MBO 수정목표 데이터 세팅
  SET_MBO_HISTORY_LIST: "SET_MBO_HISTORY_LIST", //* MBO 이력 세팅
  SET_MBO_HISTORY_CODE: "SET_MBO_HISTORY_CODE", //* MBO 이력 코드 세팅
  SET_VIEWS_MBO_HISTORY_POPUP: "SET_VIEWS_MBO_HISTORY_POPUP", //* MBO 변경이력 팝업 ON/OFF 저장
  SET_VIEWS_MBO_MODIFY_TARGET_POP: "SET_VIEWS_MBO_MODIFY_TARGET_POP", //* MBO 수정목표 팝업 ON/OFF
  SET_VIEWS_MBO_KPI_POPUP: "SET_VIEWS_MBO_KPI_POPUP", //* MBO 항목(KPI) 팝업 ON/OFF 저장
  SET_MBO_KPI_POOL_LIST: "SET_MBO_KPI_POOL_LIST", //* MBO 항목(KPI) 저장
  //SET_IS_SELECTED_NEW_KPI: 'SET_IS_SELECTED_NEW_KPI', //* 선택한 MBO 항목(KPI) 저장
  SET_MBO_BOARD_TAB: "SET_MBO_BOARD_TAB", //* MBO 현황탭 ON/OFF 저장
  SET_MBO_LIST_TAB: "SET_MBO_LIST_TAB", //* MBO 목록탭 ON/OFF 저장
  SET_SELECTED_TARGET_MBO_KPI: "SET_SELECTED_TARGET_MBO_KPI", //* 선택한 수정목표 MBO 항목 저장
  SET_CHANGED_TARGET_MBO_KPI: "SET_CHANGED_TARGET_MBO_KPI", //* 목표를 수정한 MBO KPI 저장
  SET_SELECTED_MBO_INFO: "SET_SELECTED_MBO_INFO" //* MBO목록에서 선택한 MBO 정보 저장
};
//* ROOT ACTIONS CONSTANT
export const rootActions = {
  ...Object.entries(actions).reduce((acc, cur) => {
    acc[cur[0]] = `mboOperation/${cur[1]}`;
    return acc;
  }, {})
};

//* ROOT MUTATIONS CONSTANT
export const rootMutations = {
  ...Object.entries(mutations).reduce((acc, cur) => {
    acc[cur[0]] = `mboOperation/${cur[1]}`;
    return acc;
  }, {})
};
